import { deleteQueryKeys, readTrimmedParam, writeTrimmedParam } from "@/lib/filterUrlParams";
import type { UserFilter } from "@/types/entities";

export const USER_FILTER_PARAM_KEYS = ["search", "userIntent"] as const;

export const CLEARED_USER_FILTER: Partial<UserFilter> = {
  search: undefined,
  userIntent: undefined,
};

export function parseUserFilterFromSearchParams(params: URLSearchParams): UserFilter {
  const filter: UserFilter = {};
  const search = readTrimmedParam(params, "search");
  if (search) filter.search = search;
  const userIntent = readTrimmedParam(params, "userIntent");
  if (userIntent) filter.userIntent = userIntent;
  return filter;
}

export function applyUserFilterToSearchParams(
  filter: UserFilter,
  current: URLSearchParams,
): URLSearchParams {
  const next = new URLSearchParams(current);
  deleteQueryKeys(next, USER_FILTER_PARAM_KEYS);
  writeTrimmedParam(next, "search", filter.search);
  writeTrimmedParam(next, "userIntent", filter.userIntent);
  return next;
}

function canonicalQuery(filter: UserFilter): string {
  return applyUserFilterToSearchParams(filter, new URLSearchParams()).toString();
}

export function userFiltersEquivalent(a: UserFilter, b: UserFilter): boolean {
  return canonicalQuery(a) === canonicalQuery(b);
}

export const userFilterUrlSyncConfig = {
  parseFromSearchParams: parseUserFilterFromSearchParams,
  applyToSearchParams: applyUserFilterToSearchParams,
  filtersEquivalent: userFiltersEquivalent,
  clearedFilter: CLEARED_USER_FILTER,
};
